import * as yup from 'yup';
import {
  additionalInfoSchema as _additionalInfoSchema,
  clientSchema,
  notificationSchema,
  patientSchema
} from 'src/module/FormKit/validators';

export const additionalInfoSchema = yup
  .object()
  .shape({
    productQuantity: yup
      .number()
      .required('errors.productQuantityRequired')
      .integer('errors.productQuantityRequired'),
    productDescription: yup
      .string()
      .required('errors.productDescriptionRequired')
      .min(3, 'errors.productDescriptionMinLength'),
    productComments: yup.string()
  })
  .concat(_additionalInfoSchema);

export const validationSchema = yup.object().shape({
  clientInfo: clientSchema,
  patientInfo: patientSchema,
  notificationSettings: notificationSchema,
  additionalInfo: additionalInfoSchema
});
